import {
    FIREBASE_PUSH_SCOPE,
    getFCMMessaging,
    getFCMToken,
    isPermissionDenied,
    isPermissionGranted
} from "../utils/firebase";
import { registerWorker } from "../utils/browser";
import MgrBase from "./mrg-base";
import { ConfigHelper } from "../helpers/config-helper";
import FirebaseApp from "../models/firebase-app";

export default class MgrFirebase extends MgrBase {
    static SERVICE = "webfcm";

    /**
     * check configuration validity and initialize firebase messaging class
     * add also a callback to handler onMessage
     * @param {*} config
     */
    async init() {
        const config = this._getConfig();
        const app = {
            appId: config.getAppId(),
            apiKey: config.getApiKey(),
            projectId: config.getProjectId(),
            senderId: config.getSenderId()
        };
        await ConfigHelper.saveApp(config.getPackageName(), app);

        this.messaging = getFCMMessaging(app);

        try {
            this.worker = await registerWorker({ scope: FIREBASE_PUSH_SCOPE, baseURL: config.getBaseUrl() });
        } catch (e) {
            console.warn(e.message);
        }
    }

    /**
     * start push permission request
     * ? not used
     */
    async requestPermission() {
        let token;
        try {
            token = await getFCMToken(this.messaging, {
                vapidKey: this._getConfig().getVapidKey(),
                serviceWorkerRegistration: this.worker
            });
            console.log(`Registration token: ${token}`);
        } catch (e) {
            console.log(e.message);
        }
        return token;
    }

    hasPermission() {
        return isPermissionGranted();
    }

    hasNotPermission() {
        return isPermissionDenied();
    }

    _getConfig(): FirebaseApp {
        return this._config;
    }

    _getService() {
        return MgrFirebase.SERVICE;
    }
}
